var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.99996,
    cy: 10.0001,
    r: 8.33333,
    stroke: "#333030",
    strokeWidth: 1.66667
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8145 12.4577C10.803 12.6639 11.0005 12.7876 11.4071 12.8287C11.4386 12.8319 11.4714 12.8346 11.5054 12.8368C11.6403 12.8455 11.75 12.9536 11.75 13.0887C11.75 13.2239 11.6404 13.3334 11.5053 13.3334H11.4071H8.74373H8.66131C8.52617 13.3334 8.41663 13.2239 8.41663 13.0887C8.41663 12.9536 8.52633 12.8456 8.66114 12.8362C8.68956 12.8343 8.71709 12.8319 8.74373 12.8292C9.14215 12.7886 9.34136 12.6648 9.34136 12.4577V9.84779C9.34136 9.64132 9.15179 9.51581 8.77266 9.47126C8.7342 9.46674 8.69379 9.46305 8.65144 9.4602C8.52196 9.45148 8.41663 9.34767 8.41663 9.21791C8.41663 9.07741 8.53052 8.96351 8.67102 8.96351H8.98169H10.4308H10.5286C10.6865 8.96351 10.8145 9.09148 10.8145 9.24935V12.4577ZM10.9435 7.52118C10.9435 7.7215 10.8539 7.89607 10.6747 8.04488C10.5026 8.18797 10.2876 8.25951 10.0295 8.25951C9.9005 8.25951 9.77863 8.23948 9.66394 8.19942C9.55641 8.15935 9.45964 8.10784 9.37362 8.04488C9.29476 7.9762 9.23025 7.89893 9.18007 7.81308C9.12989 7.7215 9.1048 7.6242 9.1048 7.52118C9.1048 7.31513 9.1944 7.01874 9.37362 6.88138C9.56 6.73829 9.77863 6.66675 10.0295 6.66675C10.2804 6.66675 10.4955 6.73829 10.6747 6.88138C10.8539 7.02447 10.9435 7.32085 10.9435 7.52118Z",
    fill: "#333030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/InfoIcon.aed5ca1daae3f1fd2029dc37251d4be8.svg";
export { ForwardRef as ReactComponent };